import { CancellationAireFormVM } from 'cancellations/view-models/cancellation-aire';
import { ISTAT_MILANO } from 'shell/constants/istat-milano';

export const initialValues: CancellationAireFormVM = {
  generality: {
    istatCode: ISTAT_MILANO,
    subject: '2',
    aire: '',
    anprIdentifier: '',
    birthDate: null,
    isForeign: false,
    italian: {
      municipality: null,
    },
    foreign: {
      municipality: null,
      state: null,
    },
  },
  citizenship: {
    state: null,
    validity: null,
  },
};
